const getPrescriberNPI = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber.NPI) {
    return prescriber.NPI;
  }
  if (patient.Prescriber[0]) {
    return patient.Prescriber[0].NPI;
  }
  return null;
};

export default getPrescriberNPI;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberNPI.js